var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaptop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "#17253F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_826)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00372314 20.3274H26.0035V23.0393C26.0035 23.9363 25.2719 24.6679 24.3749 24.6679H1.62489C0.727906 24.6679 -0.00372314 23.9363 -0.00372314 23.0393V20.3274ZM1.08683 21.4179V23.0393C1.08683 23.334 1.3302 23.5774 1.62489 23.5774H24.3749C24.6696 23.5774 24.9129 23.334 24.9129 23.0393V21.4179H1.08683Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62128 5.16426C1.62128 4.26727 2.35291 3.53564 3.24989 3.53564H22.7499C23.6469 3.53564 24.3785 4.26727 24.3785 5.16426V20.8726H23.2879V5.16426C23.2879 4.86957 23.0446 4.6262 22.7499 4.6262H3.24989C2.9552 4.6262 2.71183 4.86957 2.71183 5.16426V20.8726H1.62128V5.16426Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.663 24.1227V22.4977H22.7535V24.1227H21.663Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4963 24.1227V22.4977H20.5868V24.1227H19.4963Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3297 24.1227V22.4977H18.4202V24.1227H17.3297Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.831299)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaptop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop.00859445de7a92b8fb59ccdc62a41d3f.svg";